import ConferenceDashboard from '../components/Conference/Dashboard/ConferenceDashboard';
import ConferenceList from '../components/Conference/Conference/ConferenceList';
import ConferenceUsage from '../components/Conference/Usage/ConferenceUsage';
import LaborProgress from '../components/Conference/LaborProgress';
import ServiceProvider from '../components/Conference/ServiceProvider';

/**
 * 会议模块「全局壳」（MainLayout）下的路由：
 * - 看板、会议项目列表、用量、劳务进度、服务商等顶层页
 *
 * 单个会议项目相关的全部子路由（`conferences/:id/*`，含直播详情、报名模板等
 * 内层 `:liveId` / `:templateId` 子资源）已统一迁入
 * [conferenceWorkspaceLayoutRoutes](./conferenceWorkspaceLayoutRoutes.js)，
 * 由 `ConferenceWorkspaceLayout` 承接（在 [indexRoutes](./indexRoutes.js) 中注册）。
 */
const conferenceRoutes = [
    { path: '', element: <ConferenceDashboard /> },
    { path: 'conferences', element: <ConferenceList /> },
    { path: 'conferences/usage', element: <ConferenceUsage /> },
    { path: 'conferences/labor-progress', element: <LaborProgress /> },
    { path: 'conferences/service-provider', element: <ServiceProvider /> },
];

export default conferenceRoutes;
